import { useEffect } from "react";

/**
 * #root altına eklenen tüm input/textarea/select için autocomplete ve ilgili bayrakları zorlar.
 * İstisna: data-allow-autofill="true" (alan veya üst kapsayıcı)
 */
function stampElement(el) {
    if (!(el instanceof HTMLElement)) return;
    if (el.dataset.allowAutofill === "true") return;
    if (el.closest("[data-allow-autofill='true']")) return;
    const tag = el.tagName;
    if (!["INPUT", "TEXTAREA", "SELECT"].includes(tag)) return;
    el.setAttribute("autocomplete", "off");
    el.setAttribute("data-lpignore", "true");
    el.setAttribute("data-1p-ignore", "true");
    el.setAttribute("data-bwignore", "true");
    el.setAttribute("data-form-type", "other");
}

function walk(node) {
    if (!node || node.nodeType !== 1) return;
    stampElement(node);
    node.querySelectorAll?.("input, textarea, select").forEach(stampElement);
}

export function useGlobalAutofillKill() {
    useEffect(() => {
        const root = document.getElementById("root");
        if (!root) return undefined;
        walk(root);
        const mo = new MutationObserver((records) => {
            records.forEach((r) => {
                r.addedNodes.forEach((n) => walk(n));
            });
        });
        mo.observe(root, { childList: true, subtree: true });
        return () => mo.disconnect();
    }, []);
}
